import React from 'react'
import OverclaimConfirmationPopup from '@Components/Popups/ConfirmationPopup/OverclaimConfirmationPopup'
import Popup from '@Components/Popups/Popup'

export interface OverclaimWarningStepProps {
    onClickConfirm: () => void
    onClickCancel: () => void
}
const OverclaimWarningStep = (props: OverclaimWarningStepProps) => {
    const { onClickConfirm, onClickCancel } = props
    return (
        <Popup onClose={() => {}}>
            <OverclaimConfirmationPopup
                onClickConfirm={onClickConfirm}
                confirmButtonText="Continue"
                onClickCancel={onClickCancel}
            />
        </Popup>
    )
}

export default OverclaimWarningStep
